// eslint-disable-next-line no-restricted-imports
import { Button, makeStyles, Theme, withStyles } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import React, { PropsWithChildren } from 'react';
import { fade } from '@material-ui/core/styles/colorManipulator';

const CustomDropDownArrow = withStyles((theme) => ({
  root: { color: theme.palette.primary.main },
}))(ArrowDropDownIcon);

export interface FilterButtonProps {
  isActive?: boolean;
  open?: boolean;
  onClick?: () => void;
  ariaControls: string;
}

const useCustomButtonStyles = makeStyles<Theme, FilterButtonProps>((theme) => ({
  button: {
    textTransform: 'none',
    borderRadius: 0,
    padding: '2.5px 12px 2.5px 8px',
    boxShadow: 'none',
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    fontWeight: 400,
    color: fade(theme.palette.text.primary, 0.6),
    '&:active': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover': {
      borderColor: '#FF964D',
      backgroundColor: theme.palette.common.white,
    },
  },
  active: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.text.primary,
  },
}));

export const FilterButton = React.forwardRef<
  HTMLButtonElement,
  PropsWithChildren<{
    isActive?: boolean;
    open?: boolean;
    onClick?: () => void;
    ariaControls: string;
  }>
>(({ isActive, open, ariaControls, children, ...props }, ref) => {
  const styles = useCustomButtonStyles({ isActive, open, ariaControls, ...props });
  return (
    <Button
      aria-controls={open ? ariaControls : undefined}
      variant='outlined'
      disableRipple
      size='medium'
      ref={ref}
      aria-haspopup='true'
      endIcon={<CustomDropDownArrow />}
      {...props}
      className={`${styles.button} ${isActive ? styles.active : ''}`}
    >
      {children}
    </Button>
  );
});
